import { render, staticRenderFns } from "./themeManagerment.vue?vue&type=template&id=9b00e874&scoped=true"
import script from "./themeManagerment.vue?vue&type=script&lang=js"
export * from "./themeManagerment.vue?vue&type=script&lang=js"
import style0 from "./themeManagerment.vue?vue&type=style&index=0&id=9b00e874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b00e874",
  null
  
)

export default component.exports